{
  "required": "Required field",
  "maxlength": "Maximum number of characters: {{0}}",
  "minlength": "Minimum number of characters: {{0}}",
  "invalidNip": "Incorrect Tax Identification Number",
  "invalidRegon": "Incorrect REGON number",
  "positiveIntegerNumberPattern": "Required format is 123",
  "positiveDecimalNumberPattern": "Required format is 123.45",
  "number": "Required numerical format",
  "atLeastOneRequired": "At least one element required",
  "invalidPesel": "Incorrect PESEL number",
  "invalidPhoneNumber": "Incorrect phone number",
  "invalidEmail": "Incorrect email address",
  "invalidDateFormat": "Incorrect date. DD-MM-YYYY format required",
  "invalidRange": "Incorrect scope",
  "postcodePattern": "00-000 format required",
  "datePattern": "DD-MM-YYYY format required",
  "dateAfterToday": "The date cannot be later than today",
  "dateBeforeToday": "The date cannot be earlier than today",
  "maxDate": "The maximum date is {{maxDate}}",
  "minDate": "The minimum date is {{minDate}}",
  "pattern": "Incorrect format",
  "min": "The minimum number allowed is {{0}}",
  "max": "The maximum number allowed is {{0}}",
  "invalidData": "Incorrect value",
  "invalidPhoneFormat": "Incorrect format. 9-18 digits required",
  "invalidKrsFormat": "Incorrect format. 10 digits required",
  "maxAmount": "Maximum allowed amount: {{max}}"
}
